import React, { useEffect, useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";

import BottomNavBar from "./pages/commonComponents/BottomNavBar/BottemNavBar";
import MenuMainSection from "./pages/menuPage/MenuMainSection";
import LoginPage from "./pages/login-signup/LoginPage";
import SignupPage from "./pages/login-signup/SignupPage";
import Dashboard from "./pages/dashboard/Dashboard";
import EditInfo from "./pages/dashboard/components/EditInfo";
import ViewOrders from "./pages/dashboard/components/ViewOrders";
import ViewOffers from "./pages/dashboard/components/ViewOffers";
import ResetPassword from "./pages/dashboard/components/ResetPassword";
import SelectLocation from "./pages/select-location/SelectLocation";
import PlaceType from "./pages/place-select/PlaceType";
import ProtectedRoute from "./pages/commonComponents/ProtectedRoute/ProtectedRoute";
import InCafeDetail from "./pages/place-select/InCafeDetail";
import InPersonDetail from "./pages/place-select/InPersonDetail";
import InCarDetail from "./pages/place-select/InCarDetail";
import InMotorcycleDetail from "./pages/place-select/InMotorcycleDetail";
import InvoiceDetails from "./pages/dashboard/components/InvoiceDetails";
import FPStep1 from "./pages/login-signup/forget-password/FPStep1";
import FPStep2 from "./pages/login-signup/forget-password/FPStep2";
import FPStep3 from "./pages/login-signup/forget-password/FPStep3";
import ForgetPassword from "./pages/login-signup/forget-password/ForgetPassword";
import OrderSuccess from "./pages/order-result/OrderSuccess";
import OrderFail from "./pages/order-result/OrderFail";
import Payment from "./pages/commonComponents/Payment/Payment";
import PlaceSelector from "./pages/place-select/PlaceSelector";
import LoadingScreen from "./pages/commonComponents/LoadingScreen/LoadingScreen";

import { ToastContainer } from "react-toastify";

import { useShipping } from "./contexts/ShippingContext";

import { useTheme } from "./contexts/ThemeContext";

import { useDetectOffline } from "./contexts/DetectOfflineContext";
import NoConnection from "./pages/commonComponents/NoConnection";
import NotFound from "./pages/NotFound";
import ShopItems from "./pages/menuPage/components/ShopItems/ShopItems";
import InHouseDetail from "./pages/place-select/InHouseDetail";
import { useOrder } from "./contexts/OrderContext";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const { currentUser } = useAuth();
  const { isPaymentOpen } = useShipping();
  const { paymentIsPending } = useOrder();
  const { theme } = useTheme();
  const location = useLocation();
  const online = useDetectOffline();

  useEffect(() => {
    const timeout = setTimeout(() => setIsLoading(false), 6000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <LoadingScreen show={isLoading} />
      <div
        className={`main-container ${theme === "light" ? "light-mode" : ""}`}
      >
        <Routes location={location} key={location.pathname}>
          <Route
            exact
            path="/"
            element={
              <>
                <Outlet />
                <BottomNavBar />
              </>
            }
          >
            <Route index element={<MenuMainSection />} />
            <Route path="shop" element={<ShopItems />} />
            <Route
              path="dashboard"
              element={
                <ProtectedRoute condition={currentUser} redirect="/login">
                  <Dashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<EditInfo />} />
              <Route path="orders" element={<Outlet />}>
                <Route index element={<ViewOrders />} />
                <Route path=":invoiceId" element={<InvoiceDetails />} />
              </Route>
              <Route path="offers" element={<ViewOffers />} />
              <Route path="password-reset" element={<ResetPassword />} />
            </Route>
            <Route
              path="shipping/type"
              element={
                <ProtectedRoute condition={currentUser} redirect="/login">
                  <PlaceSelector />
                </ProtectedRoute>
              }
            >
              <Route index element={<PlaceType />} />
              <Route path="in-cafe" element={<InCafeDetail />} />
              {/* <Route path="in-house" element={<InHouseDetail />} /> */}
              <Route path="in-person" element={<InPersonDetail />} />
              <Route path="by-car" element={<InCarDetail />} />
              <Route path="by-motorcycle" element={<InMotorcycleDetail />} />
            </Route>

            <Route
              path="shipping/location"
              element={
                <ProtectedRoute condition={currentUser} redirect="/login">
                  <SelectLocation />
                </ProtectedRoute>
              }
            />
            <Route
              path="order-result/success"
              element={
                <ProtectedRoute condition={currentUser} redirect="/login">
                  <OrderSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="order-result/fail"
              element={
                <ProtectedRoute condition={currentUser} redirect="/login">
                  <OrderFail />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route
            path="/login"
            element={
              <ProtectedRoute condition={!currentUser} redirect="/">
                <LoginPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <ProtectedRoute condition={!currentUser} redirect="/">
                <SignupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forget-password"
            element={
              <ProtectedRoute condition={!currentUser} redirect="/">
                <ForgetPassword />
              </ProtectedRoute>
            }
          >
            <Route index element={<FPStep1 />} />
            <Route path="otp-token" element={<FPStep2 />} />
            <Route path="password-reset" element={<FPStep3 />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          theme={theme === "dark" ? "dark" : "light"}
        />
        {paymentIsPending && isPaymentOpen && <Payment />}
        {!online && <NoConnection />}
      </div>
    </>
  );
}

export default App;
